@if (isCompactMode()) {
  <div class="checkbox-compact-frame">
    <mat-checkbox
      (mousedown)="onCheckboxMouseDown($event)"
      (click)="onCheckboxClick($event)"
      (change)="onCheckboxToggle($event)"
      [checked]="isChecked()"
    ></mat-checkbox>
  </div>
} @else {
  <mat-checkbox
    (mousedown)="onCheckboxMouseDown($event)"
    (click)="onCheckboxClick($event)"
    (change)="onCheckboxToggle($event)"
    [checked]="isChecked()"
  ></mat-checkbox>
}
